/*
  Keeps the free-sample discount code attached to the cart in step with the
  number of samples in it.

  snippets/cart-form.liquid works out the right code (SAMPLE_APPLY1..3) into a
  hidden #discount field, but that field only reaches Shopify when the cart
  form is submitted at checkout. Until then the cart keeps whatever code it
  was given last, so the drawer shows a stale discount (e.g. $5 off with 3
  samples in the cart).

  This wraps Shopify.theme.ajaxCart.updateView — which every add / remove /
  quantity change in the theme ends in — and, before the drawer re-renders,
  swaps the SAMPLE_APPLY code on the cart via /cart/update.js. Any other code
  on the cart (a promo or one the customer typed) is sent back untouched.
  Adds that bypass updateView (sections/product-advanced.liquid) fire
  `cart:updated`, which is handled the same way, and the cart is checked once
  on page load for anything else.

  Plain JS on purpose: jQuery is not loaded when theme scripts run.
*/
(function () {
  if (!window.fetch || !window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart) return;
  if (Shopify.theme.ajaxCart.__sampleDiscountSync) return;

  var MAX_SAMPLES = 3;
  var CODE_PREFIX = 'SAMPLE_APPLY';
  var ajaxCart = Shopify.theme.ajaxCart;
  var originalUpdateView = ajaxCart.updateView;
  var queue = Promise.resolve();

  // Same test as cart-form.liquid: any option value containing "sample" (any case).
  function sampleCount(cart) {
    return (cart.items || []).reduce(function (n, item) {
      var values = (item.options_with_values || []).map(function (o) { return o.value; });
      var text = JSON.stringify(values).toLowerCase();
      return text.indexOf('sample') > -1 ? n + item.quantity : n;
    }, 0);
  }

  function isSampleCode(code) {
    return code.toUpperCase().indexOf(CODE_PREFIX) === 0;
  }

  // Resolves with the cart as it should be shown (updated if the code changed).
  function syncCart(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);

    var samples = Math.min(sampleCount(cart), MAX_SAMPLES);
    var current = (cart.discount_codes || []).map(function (d) { return d.code; });
    var others = current.filter(function (code) { return !isSampleCode(code); });
    var next = (samples ? [CODE_PREFIX + samples] : []).concat(others);

    if (next.join(',') === current.join(',')) return Promise.resolve(cart);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: next.join(',') })
    })
      .then(function (res) { return res.ok ? res.json() : cart; })
      .catch(function () { return cart; }); // checkout still sends the right code as a fallback
  }

  // Serialised so rapid clicks can't race each other's /cart/update.js calls.
  function enqueue(task) {
    queue = queue.then(task, task);
    return queue;
  }

  function getCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  // theme.js's add-to-cart passes the /cart/add.js response (the added line
  // item, not the cart) — fetch the cart for the sync but hand the original
  // argument back so updateView behaves exactly as before.
  ajaxCart.updateView = function (config, data) {
    var self = this;
    var isCart = data && data.items;
    return enqueue(function () {
      return (isCart ? Promise.resolve(data) : getCart())
        .then(syncCart)
        .catch(function () {})
        .then(function (synced) {
          return originalUpdateView.call(self, config, isCart && synced ? synced : data);
        });
    });
  };
  ajaxCart.__sampleDiscountSync = true;

  // For adds that never call updateView, and on page load: sync, and only
  // re-render the drawer when the code actually changed.
  function syncFromServer() {
    return enqueue(function () {
      return getCart()
        .then(function (cart) {
          var before = JSON.stringify(cart.discount_codes || []);
          return syncCart(cart).then(function (synced) {
            if (JSON.stringify(synced.discount_codes || []) === before) return;
            var configEl = document.getElementById('cart-config');
            if (!configEl) return;
            originalUpdateView.call(ajaxCart, JSON.parse(configEl.innerHTML || '{}'), synced);
          });
        })
        .catch(function () {});
    });
  }

  document.addEventListener('cart:updated', syncFromServer);
  syncFromServer();
})();
